/* ============================================================================
   DEV AASTHA - PDP V2 - EDD  (pincode -> area + state -> delivery date)
   ----------------------------------------------------------------------------
   Owner (6 Aug 2026):
     - "invalid ko invalid batao"   - "pincode ki jagah area ka naam aaye"
     - "location auto detect ho"    - "India ke bahar widget dikhe hi na"
     - "last 6 month ke orders se EDD ki timing update karo"
     - "Change pincode ko FREE delivery wali line me chota kar ke rakho"
     - "Checking / Invalid DIALOGUE BOX ke ANDAR, bina border/outline ke"
     - "pehli line EK hi line me rahe"
     - "dobara Change pincode dabane par area ki jagah pincode ghus jaata hai"

   ZAROORI: ye file da-pdp-v2.js ke BAAD load honi chahiye. Wo apna purana
   handler form par lagata hai; hum CAPTURE phase me pakad kar use rok dete hain
   (stopImmediatePropagation).
   ============================================================================ */
(function () {
  var API = 'https://api.postalpincode.in/pincode/';
  var CACHE = 'da_pin_cache_v1';

  /* ⚠⚠ YAHI KEY PURANA SCRIPT BHI PADHTA HAI (`da-pdp-v2.js` -> PIN_KEY).
     Wo isse padh kar `placeFromPin(pin)` chalata hai, jo label me SEEDHA
     PINCODE bhar deta hai ("110002") aur apni zone-wali date likh deta hai.
     Isliye dono script ek hi do jagah par likhte hain, aur jo BAAD me likhe
     wahi dikhta hai - yahi race owner ne pakdi thi.
     Neeche `guard()` isi ko rokta hai. Key badalna theek nahi - tab purana
     script har baar "Set pincode" par chala jayega. */
  var PIN_KEY = 'da_pincode';

  /* --------------------------------------------------------------------------
     DELIVERY DAYS - ASLI ORDER DATA SE (6 Aug 2026)
     --------------------------------------------------------------------------
     Shopify se 6 mahine ke fulfilled orders nikale; jinme carrier ne sach me
     deliveredAt bheja wo 387 nikle. Har state ka 75th percentile liya.
     P75 kyun: median par AADHE customers late honge. P75 par ~75% ko date se
     pehle ya us din maal milta hai. Badalna ho to bas ye table badlo.
     Jahan n 8 se kam tha wahan overall P75 (7 din) use hota hai.
  -------------------------------------------------------------------------- */
  var DAYS = {
    MH: 7, KA: 6, TN: 7, TS: 7, WB: 7, UP: 4, GJ: 8,
    HR: 4, AP: 6, DL: 4, RJ: 6, KL: 8, PB: 6
  };
  var DEFAULT_DAYS = 7;

  var STATE2CODE = {
    'andhra pradesh': 'AP', 'arunachal pradesh': 'AR', 'assam': 'AS',
    'bihar': 'BR', 'chhattisgarh': 'CG', 'goa': 'GA', 'gujarat': 'GJ',
    'haryana': 'HR', 'himachal pradesh': 'HP', 'jharkhand': 'JH',
    'karnataka': 'KA', 'kerala': 'KL', 'madhya pradesh': 'MP',
    'maharashtra': 'MH', 'manipur': 'MN', 'meghalaya': 'ML', 'mizoram': 'MZ',
    'nagaland': 'NL', 'odisha': 'OR', 'orissa': 'OR', 'punjab': 'PB',
    'rajasthan': 'RJ', 'sikkim': 'SK', 'tamil nadu': 'TN', 'telangana': 'TS',
    'tripura': 'TR', 'uttar pradesh': 'UP', 'uttarakhand': 'UK',
    'west bengal': 'WB', 'delhi': 'DL', 'nct of delhi': 'DL',
    'jammu and kashmir': 'JK', 'ladakh': 'LA', 'puducherry': 'PY',
    'pondicherry': 'PY', 'chandigarh': 'CH', 'andaman & nicobar islands': 'AN',
    'dadra & nagar haveli': 'DN', 'daman & diu': 'DD', 'lakshadweep': 'LD'
  };

  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function el(id) { return document.getElementById(id); }
  function q(sel) { return document.querySelector(sel); }

  /* ⚠ CHHOTA weekday HAMESHA ("Mon", "Monday" nahi) - desktop par bhi.
     Pehle desktop par poora naam tha, aur owner ke screenshot me date KAT gayi
     thi: "FREE delivery by Monday, 10 A...". Wajah - pehli line me text + link
     dono ko jagah chahiye, aur poora naam ~35px zyada leta hai. Date ka kat
     jaana sabse bura hai (customer ko delivery date hi nahi dikhti), isliye
     naam chhota rakhte hain. "Mon, 10 Aug" har jagah poora dikhta hai. */
  function fmt(d) {
    return DAY[d.getDay()] + ', ' + d.getDate() + ' ' + MON[d.getMonth()];
  }

  function etaFor(code) {
    var days = DAYS[code] || DEFAULT_DAYS;
    var d = new Date();
    d.setDate(d.getDate() + days);
    return d;
  }

  function cacheGet(pin) {
    try {
      var all = JSON.parse(localStorage.getItem(CACHE) || '{}');
      return all[pin] || null;
    } catch (e) { return null; }
  }
  function cacheSet(pin, val) {
    try {
      var all = JSON.parse(localStorage.getItem(CACHE) || '{}');
      all[pin] = val;
      localStorage.setItem(CACHE, JSON.stringify(all));
    } catch (e) {}
  }

  /* null = pincode hai hi nahi | object = mila | 'ERR' = network fail */
  function lookup(pin) {
    var hit = cacheGet(pin);
    if (hit) return Promise.resolve(hit === 'INVALID' ? null : hit);

    return fetch(API + pin)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = j && j[0];
        if (!d || d.Status !== 'Success' || !d.PostOffice || !d.PostOffice.length) {
          cacheSet(pin, 'INVALID');
          return null;
        }
        var po = d.PostOffice[0];
        var st = (po.State || '').trim();
        var out = {
          area: (po.Name || '').trim(),
          district: (po.District || '').trim(),
          state: st,
          code: STATE2CODE[st.toLowerCase()] || ''
        };
        cacheSet(pin, out);
        return out;
      })
      .catch(function () { return 'ERR'; });
  }

  /* ---- status text (dabbe ke andar, bina border ke) ---------------------- */
  function chip() {
    var host = q('.dapdp .deliv .pinform') || q('.dapdp .deliv .pinrow');
    if (!host) return null;
    var c = q('.dapdp .da-edd-msg');
    if (!c) {
      c = document.createElement('span');
      c.className = 'da-edd-msg';
      c.setAttribute('role', 'status');
    }
    if (c.parentElement !== host) host.appendChild(c);
    return c;
  }

  var hideTimer = null;

  function showMsg(kind, text) {
    var c = chip();
    if (!c) return;
    clearTimeout(hideTimer);
    if (!kind) { c.classList.remove('on', 'err'); return; }
    c.textContent = text;
    c.classList.toggle('err', kind === 'err');
    void c.offsetWidth;   /* reflow - warna dobara animation nahi chalti */
    c.classList.add('on');
    if (kind === 'err') {
      hideTimer = setTimeout(function () { c.classList.remove('on'); }, 4000);
    }
  }

  /* --------------------------------------------------------------------------
     GUARD - purana script hamari likhi hui value mita deta tha
     --------------------------------------------------------------------------
     Owner: "dobara Change pincode dabaya to area ki jagah 110002 ghus gaya".

     Wajah: `da-pdp-v2.js` bhi usi `da_pincode` key ko padhta hai aur apna
     `renderDelivery()` chalata hai, jisme:
         placeFromPin(v) -> { label: v }     // label = SEEDHA PINCODE
     Yani wo `#locName` me "110002" aur apni zone-wali date likh deta hai.
     Dono script ek hi jagah likhte hain, to jo BAAD me chale wahi dikhta hai -
     isliye ye kabhi hota tha kabhi nahi (race).

     Yahan hum apni aakhri value yaad rakhte hain aur agar koi aur use badal
     kar RAW PINCODE / "Set pincode" / khali kar de, to wapas likh dete hain.

     ⚠ Sirf UN haalaton me wapas likhte hain - kisi bhi badlav par nahi. Warna
     hamara apna `paint()` bhi observer ko trigger karta aur anant loop banta.
  -------------------------------------------------------------------------- */
  var LAST = null;   /* { label: '...', date: '...' } */

  function looksStale(t) {
    return /^\d{6}$/.test(t) || /set pincode/i.test(t) || t === '';
  }

  function guard() {
    var loc = el('locName');
    var dd  = el('delivDate');

    if (loc && !loc.dataset.daGuard) {
      loc.dataset.daGuard = '1';
      new MutationObserver(function () {
        if (!LAST) return;
        var t = (loc.textContent || '').trim();
        if (t === LAST.label) return;
        if (looksStale(t)) loc.textContent = LAST.label;
      }).observe(loc, { childList: true, characterData: true, subtree: true });
    }

    if (dd && !dd.dataset.daGuard) {
      dd.dataset.daGuard = '1';
      new MutationObserver(function () {
        if (!LAST || !LAST.date) return;
        var t = (dd.textContent || '').trim();
        if (t === LAST.date || t === '—') return;
        /* purana script poora weekday likhta hai ("Monday, 10 Aug") aur apni
           zone-wali date - dono galat. Hamari wapas laao. */
        dd.textContent = LAST.date;
      }).observe(dd, { childList: true, characterData: true, subtree: true });
    }
  }

  function paint(place) {
    var eta = etaFor(place.code);
    var label = place.area;
    if (place.district && place.district.toLowerCase() !== place.area.toLowerCase()) {
      label += ', ' + place.district;
    } else if (place.state) {
      label += ', ' + place.state;
    }
    var dateText = fmt(eta);

    LAST = { label: label, date: dateText };

    var loc = el('locName');   if (loc) loc.textContent = label;
    var dd  = el('delivDate'); if (dd)  dd.textContent  = dateText;
    var st  = el('stickyDeliv'); if (st) st.textContent = 'FREE delivery ' + dateText;

    var box = q('.dapdp .deliv');
    if (box) box.style.display = '';
    showMsg(null);
  }

  /* ⚠ Galat pincode par AREA bhi saaf karna zaroori hai - warna purana area
     laga rehta tha aur lagta ki pincode chal gaya. */
  function clearEta() {
    LAST = null;                /* guard ko bhi rok do */
    var dd = el('delivDate'); if (dd) dd.textContent = '—';
    var loc = el('locName');  if (loc) loc.textContent = '—';
    var st = el('stickyDeliv'); if (st) st.textContent = 'Enter a valid pincode';
    var cut = el('cutLine'); if (cut) cut.textContent = '';
  }

  /* --------------------------------------------------------------------------
     PEHLI LINE: "FREE delivery by <date>" + "Change pincode" EK LINE ME
     --------------------------------------------------------------------------
     ⚠⚠ SIRF `.lead` ko flex kar dena GALAT tha. Uske andar sadhaaran text aur
     `<b>` tags hain; flex banate hi HAR text-node aur HAR `<b>` apna alag flex
     item ban gaya aur teen-chaar line me bikhar gaya
     ("FREE / delivery / by / Monday, 10 / Aug").
     Isliye saara text pehle EK span me lapet dete hain - ab flex me sirf do
     item hain: text aur link.
  -------------------------------------------------------------------------- */
  function buildLead() {
    var lead = q('.dapdp .deliv .lead');
    if (!lead) return;

    var btn = q('.dapdp .deliv .chg') || q('.dapdp .deliv [data-pintoggle]');

    if (btn && !btn.dataset.daMoved) {
      btn.dataset.daMoved = '1';
      lead.appendChild(btn);
    }

    if (!lead.querySelector('.da-lead-txt')) {
      var txt = document.createElement('span');
      txt.className = 'da-lead-txt';
      var moves = Array.prototype.slice.call(lead.childNodes).filter(function (n) {
        return n !== btn;
      });
      moves.forEach(function (n) { txt.appendChild(n); });
      if (btn) lead.insertBefore(txt, btn); else lead.appendChild(txt);
    }
  }

  function wire() {
    var form = q('[data-pinform]');
    var inp  = q('[data-pininput]');
    if (!form || !inp) return false;

    buildLead();
    chip();
    guard();

    if (form.dataset.daEdd) return true;
    form.dataset.daEdd = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var v = (inp.value || '').trim();

      if (!/^[1-9][0-9]{5}$/.test(v)) {
        showMsg('err', 'Invalid pincode');
        clearEta();
        return;
      }

      showMsg('wait', 'Checking…');

      lookup(v).then(function (place) {
        if (place === 'ERR') {
          /* Network gaya. Customer ko rokna galat hoga - sahi pincode daal kar
             bhi atak jayega. Default EDD dikhate hain, area ka naam nahi. */
          paint({ area: v, district: '', state: '', code: '' });
          return;
        }
        if (!place) {
          showMsg('err', 'Invalid pincode');
          clearEta();
          return;
        }
        try { localStorage.setItem(PIN_KEY, v); } catch (e2) {}
        paint(place);
        form.classList.remove('on');
      });
    }, true);

    return true;
  }

  var IP_SRC = [
    { url: 'https://ipwho.is/', read: function (j) { return { ok: j && j.success !== false && j.country_code === 'IN', city: j.city, region: j.region }; } },
    { url: 'https://ipapi.co/json/', read: function (j) { return { ok: j && j.country_code === 'IN', city: j.city, region: j.region }; } }
  ];

  function hideWidget() {
    var box = q('.dapdp .deliv');
    if (box) box.style.display = 'none';
    var st = el('stickyDeliv');
    if (st) st.textContent = '';
  }

  function autoDetect() {
    var saved = null;
    try { saved = localStorage.getItem(PIN_KEY); } catch (e) {}

    if (saved && /^[1-9][0-9]{5}$/.test(saved)) {
      var inp = q('[data-pininput]');
      if (inp) inp.value = saved;
      lookup(saved).then(function (p) {
        if (p && p !== 'ERR') paint(p);
      });
      return;
    }

    (function tryNext(i) {
      if (i >= IP_SRC.length) return;
      var src = IP_SRC[i];
      fetch(src.url)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var got;
          try { got = src.read(j); } catch (e) { got = null; }

          /* India ke bahar - widget dikhna hi nahi chahiye */
          if (got && !got.ok) { hideWidget(); return; }

          if (got && got.ok) {
            var code = STATE2CODE[(got.region || '').toLowerCase()] || '';
            paint({
              area: got.city || got.region || 'your area',
              district: '',
              state: got.region || '',
              code: code
            });
            return;
          }
          tryNext(i + 1);
        })
        .catch(function () { tryNext(i + 1); });
    })(0);
  }

  /* da-pdp-v2.js defer se aata hai - form thodi der baad banta hai */
  var tries = 0;
  (function boot() {
    if (wire()) { autoDetect(); return; }
    if (++tries > 40) return;
    setTimeout(boot, 250);
  })();
})();
